import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section id="home" className="hero">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="hero-content"
      >
        <h1>Building Digital Solutions That Scale</h1>
        <p>
          Ellentra Technologies delivers modern web, system and SaaS solutions,
          empowering businesses and communities through innovation and education.
        </p>
        <button>Get In Touch</button>
      </motion.div>
    </section>
  );
}
